<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.mobile" v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" v-on="on" class="elevation-0 mb-2">
          <v-icon>add</v-icon>Thêm có sẵn
        </v-btn>
      </template>
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>Thêm mới</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <autocomplete-root-major
            v-model="root"
            item-text="title"
            item-value="id"
            label="Khối"
            return-object
            required
            single-line
          ></autocomplete-root-major>
          <v-select
            outlined
            v-if="root"
            :items="root.majors"
            v-model="selectedMajor"
            label="Chuyên Ngành"
            item-text="title"
            item-value="id"
            single-line
            return-object
            @change="fetchCourse()"
            dense
          ></v-select>
          <v-select
          outlined
            v-if="selectedMajor"
            :items="courses"
            v-model="selectedCourses"
            label="Chuyên Ngành"
            item-text="title"
            deletable-chips
            clear-icon="mdi-close"
            clearable
            chips
            small-chips
            item-value="id"
            multiple
            return-object
            dense
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="save">
            <v-icon dark>add</v-icon>
            <span>Lưu</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteRootMajor from '@/components/basic/input/AutocompleteRootMajor.vue'
import { Major } from '@/plugins/api'

export default {
  props: {
    major: Object
  },
  data () {
    return {
      dialog: false,
      root: null,
      selectedMajor: null,
      selectedCourses: [],
      courses: []
    }
  },
  created () {},
  methods: {
    ...mapActions('major', ['updateMajor']),
    async fetchCourse () {
      const major = await Major.fetchOne(this.selectedMajor.id)
      this.courses = major.courses
    },
    save () {
      this.updateMajor({
        ...this.major,
        courses: [...this.major.courses, ...this.selectedCourses]
      })
      this.dialog = false
      this.reset()
    },
    cancel () {
      this.dialog = false
      this.reset()
    },
    reset () {
      this.root = null
      this.selectedMajor = null
      this.courses = []
      this.selectedCourses = []
    }
  },
  components: {
    AutocompleteRootMajor
  }
}
</script>
